// The one place the three causes are named. The stored keys are
// `trees` / `food` / `education` and never change — these are display labels
// only, so renaming a cause is a label edit rather than a data migration.

export const CAUSE_LABEL = {
    trees: "Tree Plantation",
    food: "Food Drives",
    education: "Child Welfare",
};

/** Ordered options for <select> / filter controls. */
export const CAUSE_OPTIONS = Object.entries(CAUSE_LABEL).map(([value, label]) => ({
    value,
    label,
    key: value, // some lists key on `key` rather than `value`
}));

/** Label for a stored key, falling back to the key itself if unrecognised. */
export const causeLabel = (key) => CAUSE_LABEL[key] ?? key ?? "";
